module.exports = __webpack_public_path__ + "static/media/search.9ca05e12.svg";